import styled from 'styled-components';

export const Container = styled.div`
    background: #FFFFFF;
    border-bottom: 1px solid ${ ({ theme: { borderColor } }) => borderColor };
    display: flex;
    flex-direction: column;
    height: 100%;
    margin-bottom: 10px;
    padding-bottom: 10px;
    &:last-child {
        border-bottom: none;
        margin-bottom: 0;
        padding-bottom: 0;
    }
`;
Container.displayName = 'Container';

export const Title = styled.p`
    color: ${ ({ theme: { textColor } }) => textColor };
    font-size: 1rem;
    font-weight: 500;
    margin-bottom: 15px;
`;
Title.displayName = 'Title';
